/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * PromptTemplatePlaceholderApi - axios parameter creator
 * @export
 */
export const PromptTemplatePlaceholderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentPromptTemplatePlaceholders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_template_placeholders/follow_up_necessity_judgment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @summary ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHearingItemExtractionPromptTemplatePlaceholders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_template_placeholders/hearing_item_extraction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestionExtractionPromptTemplatePlaceholders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_template_placeholders/next_action_suggestion_extraction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 要約プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 要約プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionSummaryPromptTemplatePlaceholders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/prompt_template_placeholders/transcription_summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptTemplatePlaceholderApi - functional programming interface
 * @export
 */
export const PromptTemplatePlaceholderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptTemplatePlaceholderApiAxiosParamCreator(configuration)
    return {
        /**
         * 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @summary ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHearingItemExtractionPromptTemplatePlaceholders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHearingItemExtractionPromptTemplatePlaceholders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextActionSuggestionExtractionPromptTemplatePlaceholders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextActionSuggestionExtractionPromptTemplatePlaceholders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 要約プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 要約プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptionSummaryPromptTemplatePlaceholders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptionSummaryPromptTemplatePlaceholders(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PromptTemplatePlaceholderApi - factory interface
 * @export
 */
export const PromptTemplatePlaceholderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptTemplatePlaceholderApiFp(configuration)
    return {
        /**
         * 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options).then((request) => request(axios, basePath));
        },
        /**
         * ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @summary ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHearingItemExtractionPromptTemplatePlaceholders(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getHearingItemExtractionPromptTemplatePlaceholders(options).then((request) => request(axios, basePath));
        },
        /**
         * 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextActionSuggestionExtractionPromptTemplatePlaceholders(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getNextActionSuggestionExtractionPromptTemplatePlaceholders(options).then((request) => request(axios, basePath));
        },
        /**
         * 要約プロンプトテンプレートプレースホルダー一覧取得API
         * @summary 要約プロンプトテンプレートプレースホルダー一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionSummaryPromptTemplatePlaceholders(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getTranscriptionSummaryPromptTemplatePlaceholders(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptTemplatePlaceholderApi - interface
 * @export
 * @interface PromptTemplatePlaceholderApi
 */
export interface PromptTemplatePlaceholderApiInterface {
    /**
     * 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
     * @summary 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApiInterface
     */
    getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @summary ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApiInterface
     */
    getHearingItemExtractionPromptTemplatePlaceholders(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @summary 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApiInterface
     */
    getNextActionSuggestionExtractionPromptTemplatePlaceholders(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

    /**
     * 要約プロンプトテンプレートプレースホルダー一覧取得API
     * @summary 要約プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApiInterface
     */
    getTranscriptionSummaryPromptTemplatePlaceholders(options?: AxiosRequestConfig): AxiosPromise<Array<string>>;

}

/**
 * PromptTemplatePlaceholderApi - object-oriented interface
 * @export
 * @class PromptTemplatePlaceholderApi
 * @extends {BaseAPI}
 */
export class PromptTemplatePlaceholderApi extends BaseAPI implements PromptTemplatePlaceholderApiInterface {
    /**
     * 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
     * @summary 追客要否判断プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApi
     */
    public getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options?: AxiosRequestConfig) {
        return PromptTemplatePlaceholderApiFp(this.configuration).getFollowUpNecessityJudgmentPromptTemplatePlaceholders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @summary ヒアリング項目抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApi
     */
    public getHearingItemExtractionPromptTemplatePlaceholders(options?: AxiosRequestConfig) {
        return PromptTemplatePlaceholderApiFp(this.configuration).getHearingItemExtractionPromptTemplatePlaceholders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @summary 次のアクション情報抽出プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApi
     */
    public getNextActionSuggestionExtractionPromptTemplatePlaceholders(options?: AxiosRequestConfig) {
        return PromptTemplatePlaceholderApiFp(this.configuration).getNextActionSuggestionExtractionPromptTemplatePlaceholders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 要約プロンプトテンプレートプレースホルダー一覧取得API
     * @summary 要約プロンプトテンプレートプレースホルダー一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptTemplatePlaceholderApi
     */
    public getTranscriptionSummaryPromptTemplatePlaceholders(options?: AxiosRequestConfig) {
        return PromptTemplatePlaceholderApiFp(this.configuration).getTranscriptionSummaryPromptTemplatePlaceholders(options).then((request) => request(this.axios, this.basePath));
    }
}
